import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils'
import { Loader2 } from 'lucide-react'

const buttonVariants = cva(
  'btn',
  {
    variants: {
      variant: {
        primary: 'btn-primary',
        secondary: 'btn-secondary',
        ghost: 'btn-ghost',
        danger: 'btn-danger',
      },
      size: {
        sm: 'btn-sm',
        default: '',
        lg: 'btn-lg',
        icon: 'btn-icon',
      },
      fullWidth: {
        true: 'btn-full',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  }
)

export default function Button({
  children,
  className,
  variant,
  size,
  fullWidth,
  loading,
  disabled,
  ...props
}) {
  return (
    <button
      className={cn(
        buttonVariants({ variant, size, fullWidth }),
        loading && 'btn-loading',
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <Loader2 size={16} className="tw:animate-spin" />}
      {children}
    </button>
  )
}
